import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  TablePagination,
  Box,
} from "@mui/material";
import CollectPigmyModal from "./CollectPigmyModal"; // Import the modal component
import { fetchTodayPigmyCollections } from "../../services/pigmyService";
import moment from "moment";

// Sample data

const PigmyCollectionTable = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [pigmyData, setPigmyData] = useState([]);
  const [totalPigmyCount, setTotalPigmyCount] = useState(0); // Track total loans

  const fetchData = async () => {
    // Fetch loan data from API (pagination and search term passed)
    const collections = await fetchTodayPigmyCollections(page, rowsPerPage);
    setPigmyData(collections.collectedPigmys);
    setTotalPigmyCount(collections.totalCollectedPigmys); // Update total loan count for pagination
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleModalSubmit = (values) => {
    console.log("Form Submitted", values);
    handleModalClose();
  };

  return (
    <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          m: 2,
        }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{
            py: 0.5,
            textTransform: "capitalize",
            fontSize: "16px",
            borderRadius: "8px",
          }}
          onClick={handleModalOpen} // Open modal on click
        >
          Collect Pigmy
        </Button>
        <TextField
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ py: 0.5, backgroundColor: "#fff", borderRadius: 8 }}
        />
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{ color: "#5252ff", padding: "4px", margin: "0px" }}
              align="center"
            >
              SL.NO
            </TableCell>
            <TableCell
              sx={{ color: "#5252ff", padding: "4px", margin: "0px" }}
              align="center"
            >
              CUSTOMER NAME
            </TableCell>
            <TableCell
              sx={{ color: "#5252ff", padding: "4px", margin: "0px" }}
              align="center"
            >
              AGENT NAME
            </TableCell>
            <TableCell
              sx={{ color: "#5252ff", padding: "4px", margin: "0px" }}
              align="center"
            >
              COLLECTION AMOUNT
            </TableCell>
            <TableCell
              sx={{ color: "#5252ff", padding: "4px", margin: "0px" }}
              align="center"
            >
              Paid Amount
            </TableCell>
            <TableCell
              sx={{ color: "#5252ff", padding: "4px", margin: "0px" }}
              align="center"
            >
              COLLECTION DATE
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pigmyData.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell sx={{ padding: "4px", margin: "0px" }} align="center">
                {index + 1}
              </TableCell>
              <TableCell sx={{ padding: "4px", margin: "0px" }} align="center">
                {row?.pigmy?.user?.userName}
              </TableCell>
              <TableCell sx={{ padding: "4px", margin: "0px" }} align="center">
                {row?.pigmy?.agent?.userName}
              </TableCell>
              <TableCell sx={{ padding: "4px", margin: "0px" }} align="center">
                {row?.collectionAmount.toFixed(2)}
              </TableCell>
              <TableCell sx={{ padding: "4px", margin: "0px" }} align="center">
                {row?.paidAmount.toFixed(2)}
              </TableCell>
              <TableCell sx={{ padding: "4px", margin: "0px" }} align="center">
                {moment(row?.collectionDate).format("DD-MM-YYYY")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={totalPigmyCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/* Modal for Collect Pigmy */}
      <CollectPigmyModal
        open={openModal}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
      />
    </TableContainer>
  );
};

export default PigmyCollectionTable;
